import Phaser from "phaser";
import { AudioManager } from "../../AudioManager";
import { Preferences } from "../../Preferences";

export class AudioButtonsContainer extends Phaser.GameObjects.Container {
    private musicButton!: Phaser.GameObjects.Image;
    private sfxButton!: Phaser.GameObjects.Image;

    constructor(scene: Phaser.Scene) {
        super(scene);
        const buttons = [
            { x: -50, frame: `btn_soundtrack_${Preferences.musicMuted ? "off" : "on"}`, toggle: () => AudioManager.toggleMusic() },
            { x: 50, frame: `btn_sfx_${Preferences.sfxMuted ? "off" : "on"}`, toggle: () => AudioManager.toggleSfx() }
        ];
        for (const { x, frame, toggle } of buttons) {
            const image = new Phaser.GameObjects.Image(scene, x, 0, "texture_atlas_1", frame)
                .setData("audioControl", true)
                .setInteractive({ useHandCursor: true });
            image.on("pointerover", () => image.setScale(1.05));
            image.on("pointerout", () => image.setScale(1));
            image.on("pointerdown", () => {
                toggle();
                this.refresh();
            });
            if (x < 0) this.musicButton = image;
            else this.sfxButton = image;
            this.add(image);
        }
    }

    public refresh(): void {
        this.musicButton.setFrame(`btn_soundtrack_${Preferences.musicMuted ? "off" : "on"}`);
        this.sfxButton.setFrame(`btn_sfx_${Preferences.sfxMuted ? "off" : "on"}`);
    }
}
